import React from "react";

import { socialMedia } from "../../data/links";

import Facebook from "../icons/Facebook";
import Twitter from "../icons/Twitter";
import Behance from "../icons/Behance";
import Dribbble from "../icons/Dribbble";
import Instagram from "../icons/Instagram";

import { A } from "../shared";
import { Socials as StyledSocials, SocialsItem } from "./styles";

const iconComponent = {
    Facebook,
    Twitter,
    Behance,
    Dribbble,
    Instagram
};

export const Socials = () => (
    <StyledSocials>
        {socialMedia.map(link => {
            const { name, href } = link;

            const Icon = iconComponent[name];

            return (
                <SocialsItem key={name}>
                    <A href={href} alt={`Noun Project ${name}`} target="_blank">
                        <Icon title={`${name} logo`} />
                    </A>
                </SocialsItem>
            );
        })}
    </StyledSocials>
);
